import {RemotePostCheckoutRecurrence} from 'data/usecases';
import {PostCheckoutRecurrence} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostCheckoutRecurrence = (): PostCheckoutRecurrence =>
	new RemotePostCheckoutRecurrence(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.checkoutRecurrence),
		makeAuthorizeHttpClientDecorator(),
	);
